import { styled } from "@mui/material";

export const TypeWrapper = styled("div")`
  display: flex;
  align-items: center;
`;
